import { configureStore } from '@reduxjs/toolkit';
import moneyReducer from './features/moneySlice';
import appointmentReducer from './features/appointmentSlice';
import videoReducer from './features/videoSlice';

export const store = configureStore({
    reducer: {
        money: moneyReducer,
        appointment: appointmentReducer,
        video: videoReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
            immutableCheck: false,
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
